// extracted by mini-css-extract-plugin
var _1 = "EntityProfileBuildingItem-moduleEntityProfileBuildingItem__QUpKc ListItem-moduleListItem__NInUA";
var _2 = "EntityProfileBuildingItem-moduletext__Qtxw5";
export { _1 as "EntityProfileBuildingItem", _2 as "text" }
